export enum EventType {
  TextViewerEntered = 'text-viewer/event/TextViewerEntered',
  TextViewerDataLoadRequired = 'text-viewer/event/TextViewerDataLoadRequired',
  TextViewerDataLoadCompleted = 'text-viewer/event/TextViewerDataLoadCompleted',
  TextViewerMetaLoadCompleted = 'text-viewer/event/TextViewerMetaLoadCompleted',
  TextViewerPreloadCompleted = 'text-viewer/event/TextViewerPreloadCompleted',
  TextViewerChapterLoadCompleted = 'text-viewer/event/TextViewerChapterLoadCompleted',
  CurrentChapterChanged = 'text-viewer/event/CurrentChapterChanged',
  TextViewerContentLoadRequired = 'text-viewer/event/TextViewerContentLoadRequired',
  TextViewerContentLoadCompleted = 'text-viewer/event/TextViewerContentLoadCompleted',
  CurrentPageCountRequired = 'text-viewer/event/CurrentPageCountRequired',
  AllPageCountRequired = 'text-viewer/event/AllPageCountRequired',
  AllPageCountCompleted = 'text-viewer/event/AllPageCountCompleted',
  RedrawContentRequired = 'text-viewer/event/RedrawContentRequired',
  RedrawContentCompleted = 'text-viewer/event/RedrawContentCompleted',
  ApplyScrollViewerRateRequired = 'text-viewer/event/ApplyScrollViewerRateRequired',
  ApplyScrollViewerRateCompleted = 'text-viewer/event/ApplyScrollViewerRateCompleted',
  ApplyPageViewerRateRequired = 'text-viewer/event/ApplyPageViewerRateRequired',
  ApplyPageViewerRateCompleted = 'text-viewer/event/ApplyPageViewerRateCompleted',
  UpdateScrollViewerCurrentRateRequired = 'text-viewer/event/UpdateScrollViewerCurrentRateRequired',
  UpdatePageViewerCurrentRateRequired = 'text-viewer/event/UpdatePageViewerCurrentRateRequired',
  TextViewerErrorOccurred = 'text-viewer/event/TextViewerErrorOccurred',
}
